<template>
<div>
    <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4 d-lg-flex d-none d-print-none">
        <b-nav-item :active="curTab === 'full'" @click="curTab = 'full'">
            Full Assessment
        </b-nav-item>
        <b-nav-item :active="curTab === 'summary'" @click="curTab = 'summary'">
            Summary
        </b-nav-item>
    </ul>

    <div v-show="curTab === 'full'" class="d-print-none">
        <inspection-assessment-list :sections="sections" :result_labels="result_labels"></inspection-assessment-list>
    </div>
    <div v-show="curTab === 'summary'" class="d-print-none">
        <h5 class="mt-4 mb-1 text-primary">Action Items ({{ sectionNonCompliant.length }})</h5>
        <hr class="mt-1 mb-3">
        <div v-if="sectionNonCompliant.length > 0">
            <inspection-assessment-list :sections="sectionNonCompliant" :result_labels="result_labels" :canEdit="canEdit"></inspection-assessment-list>
        </div>
        <div v-else>
            -- None --
        </div>

        <h5 class="mt-5 mb-1 text-primary">Compliant Items ({{ sectionCompliant.length }})</h5>
        <hr class="mt-1 mb-3">
        <inspection-assessment-list :sections="sectionCompliant" :result_labels="result_labels" :canEdit="canEdit"></inspection-assessment-list>
    </div>

    <!-- Yes, these are direct copies of the tab content. This is for the print view where we want hidden tabs -->
    <div class="d-none d-print-block">
        <div v-if="curTab == 'full'">
            <div class="mt-3">
                <inspection-assessment-list :sections="sections" :result_labels="result_labels"></inspection-assessment-list>
            </div>
        </div>
        <div v-else-if="curTab == 'summary'">
            <inspection-assessment-list :sections="sectionNonCompliant" :result_labels="result_labels"></inspection-assessment-list>
        </div>
    </div>
</div>
</template>

<script>
export default {

    props: {
        sections: {
            type: Array,
            default: () => [],
        },

        canEdit: {
            type: Boolean,
            default: false,
        },

        result_labels: {
            type: Object,
            default: () => ({
                compliant: 'Compliant',
                noncompliant: 'Non-Compliant',
                na: 'N/A',
            }),
        },
    },

    data: function() {
        return {
            curTab: 'full',
            activeTab: 0,
        }
    },

    computed: {

        sectionNonCompliant(){
            //Setup a local array
            var sections = [];

            //Loop
            for (var i = 0; i < this.sections.length; i++)
            {
                //Set a local help of has been added
                var sectionAdded = false;

                //Loop through the elements
                for (var j = 0; j < this.sections[i]['elements'].length; j++)
                {
                    //Check for compliance
                    if(this.sections[i]['elements'][j]['ComplianceStatusId'] == 2)
                    {
                        //Check if the section has been added
                        if(!sectionAdded)
                        {
                            //Build the formatted section
                            var formattedSection = {
                                CreatedBy: this.sections[i]['CreatedBy'],
                                Description: this.sections[i]['Description'],
                                DisplayOrder: this.sections[i]['DisplayOrder'],
                                InspectionSectionId: this.sections[i]['InspectionSectionId'],
                                IsActive: this.sections[i]['IsActive'],
                                ModifiedBy: this.sections[i]['ModifiedBy'],
                                SectionName: this.sections[i]['SectionName'],
                                SmartBizClientId: this.sections[i]['SmartBizClientId'],
                                created_at: this.sections[i]['created_at'],
                                elements: [],
                            };

                            //Push it onto the array
                            sections.push(formattedSection);

                            //Set the helper
                            sectionAdded = true;
                        }

                        //Push onto the array
                        sections[(sections.length - 1)]['elements'].push(this.sections[i]['elements'][j]);
                    }
                }
            }

            //Send it
            return sections;
        },

        sectionCompliant(){
            //Setup a local array
            var sections = [];

            //Loop
            for (var i = 0; i < this.sections.length; i++)
            {
                //Set a local help of has been added
                var sectionAdded = false;

                //Loop through the elements
                for (var j = 0; j < this.sections[i]['elements'].length; j++)
                {
                    //Check for compliance
                    if(this.sections[i]['elements'][j]['ComplianceStatusId'] != 2)
                    {
                        //Check if the section has been added
                        if(!sectionAdded)
                        {
                            //Build the formatted section
                            var formattedSection = {
                                CreatedBy: this.sections[i]['CreatedBy'],
                                Description: this.sections[i]['Description'],
                                DisplayOrder: this.sections[i]['DisplayOrder'],
                                InspectionSectionId: this.sections[i]['InspectionSectionId'],
                                IsActive: this.sections[i]['IsActive'],
                                ModifiedBy: this.sections[i]['ModifiedBy'],
                                SectionName: this.sections[i]['SectionName'],
                                SmartBizClientId: this.sections[i]['SmartBizClientId'],
                                created_at: this.sections[i]['created_at'],
                                elements: [],
                            };

                            //Push it onto the array
                            sections.push(formattedSection);

                            //Set the helper
                            sectionAdded = true;
                        }

                        //Push onto the array
                        sections[(sections.length - 1)]['elements'].push(this.sections[i]['elements'][j]);
                    }
                }
            }

            //Send it
            return sections;
        }

    },

    methods: {

    },

    mounted() {
        //Get the inspections

    }
}
</script>
